import React from 'react';
import {AppBar, Toolbar, Button, Box} from '@mui/material';
import {ThemeToggler} from 'theme/ThemeToggler';
import {Logo} from 'components/Logo';
import {LogoutButton} from './login/LogoutButton';
import NotificationsList from './notifications/NotificationsList';
import UserMenu from './menu/UserMenu';

const Navbar: React.FC = () => {
   return (
      <AppBar position="static" color="default">
         <Toolbar>
            {/* <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
               My File Explorer
            </Typography> */}
            <Box sx={{flexGrow: 1}}>
               <Logo />
            </Box>
            <NotificationsList />
            <ThemeToggler />
            <UserMenu />
         </Toolbar>
      </AppBar>
   );
};

export default Navbar;
